/**
 * Which record an Account Group Rule reads its values from. Mirrors the RuleSource enum in
 * RightsLine.Data.AccountingProcesses.Models -- keep the values in sync.
 *
 * Contact rules match against the Party contact populated on the Deal; Amount rules match
 * against the Amount's own characteristic data (Revenue Type, Media, Territory).
 */
export enum RuleSource {
	Contact = 1,
	Amount = 2
}
